import axiosInstance from '@/utils/api.js'

var state = {
  login: [],
  timeZone: []
}

var getters = {
  LOGIN: (state) => {
    return state.login
  },
  TIME_ZONE: (state) => {
    return state.timeZone
  }
}

var mutations = {
  SET_LOGIN: (state, payload) => {
    state.login = payload
  },
  SET_TZ: (state, payload) => {
    state.timeZone = payload
  }
}

var actions = {
  POST_LOGIN: async (context, payload) => {
    let result = await axiosInstance.post('/login', payload)
    context.commit('SET_LOGIN', result.data)
  },
  SET_TIME_ZONE: (context, payload) => {
    context.commit('SET_TZ', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/login.js